import { jsx } from 'react/jsx-runtime';
import { ItemTreeNode } from '../../util/ItemTree/ItemTreeNode.js';

/**
 * A menu item for use in a menu.
 */
function MenuItem(props) {
  return /*#__PURE__*/jsx(ItemTreeNode, {
    type: "menu-item",
    props: props
  });
}

export { MenuItem };
